import { Injectable } from '@angular/core';
import { UntypedFormControl, Validators, UntypedFormGroup } from '@angular/forms';
import isEmpty from 'lodash-es/isEmpty';

import { TRAVELER_FORM_INPUTS } from '@booking/constants/forms.constants';
import { booleanValidator } from '@reservation/validators/boolean-validator';
import { BusinessRulesByBookingType } from '@app/entities/booking-documents';

@Injectable()
export class PaxFormDocumentService {

  constructor() { }

  public hasPassportRestriction(isAnInternationalTrip: boolean, businessRules: BusinessRulesByBookingType): boolean {
    return !!isAnInternationalTrip && !isEmpty(businessRules) &&
      !!businessRules.ENABLED_PAX_MODULE_MANDATORY_PASSPORT;
  }

  public addDocumentRestriction(form: UntypedFormGroup, value: boolean): void {
    form?.addControl(TRAVELER_FORM_INPUTS.INTERNATIONAL_DOCUMENT_REQUIRED, new UntypedFormControl(value,
      [Validators.required, booleanValidator]));
  }

}
